/*
 * 12.05.2025
 * Copyright (c) 2025 SONS LIMITED, All Rights Reserved.
 */
import { useState, useEffect } from "react";

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 768);
    }

    window.addEventListener("resize", handleResize);
    // Cleanup listener on unmount:
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}
